import React, {ComponentProps, useCallback, useRef} from "react";
import "@react-three/fiber";
import {Canvas} from "@react-three/fiber";
import {softShadows} from "@react-three/drei";

import {ViewerScene} from "./ViewerScene";

softShadows();

export const DEFAULT_TARGET_SIZE = 6; // Target "size" of the longest side of the bounding box of the geometry
export const DEFAULT_GRID_SIZE   = 10;

const CANVAS_DEFAULT_CAMERA: ComponentProps<typeof Canvas>['camera'] = {fov: 40};

export const ViewerCanvas: React.FC<{
  url?: string;
  className?: string;
}> = (
  {
    url,
    className,
  }
) => {

  const canvas = useRef<HTMLCanvasElement | null>(null);

  const getViewerBounds = useCallback(() => {
    return canvas.current?.getBoundingClientRect();
  }, [canvas]);

  return <Canvas
    shadows
    className={className}
    camera={CANVAS_DEFAULT_CAMERA}
    ref={canvas}
  >
    <ViewerScene
      url={url}
      getViewerBounds={getViewerBounds}
    />
  </Canvas>;
};
